<template>
  <v-app>
    <!-- COVID NOTIFICATION -->
    <covid :covidNotify="covidNotify" @closeCovid="closeCovid()"></covid>
    <!-- LOADING COMPONENT -->
    <loading></loading>
    <!-- PROGRESS COMPONENT -->
    <appProgress></appProgress>
    <!-- NAVIGATION -->
    <div v-if="this.$vuetify.breakpoint.mdAndUp === true">
      <v-navigation-drawer app permanent>
        <v-list-item>
          <v-img src="@/assets/mount-logo-black.jpeg"></v-img>
        </v-list-item>
        <div class="title text-center">Online Forms</div>
        <v-divider></v-divider>
        <navDrawer></navDrawer>
      </v-navigation-drawer>
    </div>
    <div v-else>
      <v-app-bar dense>
        <v-app-bar-nav-icon @click="nav = !nav"></v-app-bar-nav-icon>
        <v-toolbar-title>
          The Mount - Online Forms
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <div class="text-right">
            <v-img src="@/assets/mount-logo-black-notext.png" contain height="42px" width="42px"></v-img>
          </div>
        </v-toolbar-items>
      </v-app-bar>
      <v-navigation-drawer app v-model="nav">
        <navDrawer></navDrawer>
      </v-navigation-drawer>
    </div>
    <!-- END NAVIGATION -->
    <v-main class="gray lighten-3">
      <v-container fluid>
        <!-- TOAST COMPONENT -->
        <toast></toast>
        <!-- ALL ROUTED COMPONENTS HERE -->
        <v-row align="start" justify="start">
          <v-col sm="12" md="10" offset-md="1" align-self="start">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import appProgress  from '@/components/appComponents/progress'
import covid        from '@/components/appComponents/covid'
import loading      from '@/components/appComponents/loading'
import mixins       from '@/plugins/mixins.js'
import navDrawer    from '@/components/appComponents/nav'
import toast        from '@/components/appComponents/toast'
export default {
  mixins: [mixins],
  components: {
    appProgress,
    covid,
    loading,
    navDrawer,
    toast
  },
  data(){
    return {
      covidNotify : false,
      nav         : false,
    }
  },
  methods: {
    closeCovid(){
      this.covidNotify = !this.covidNotify
    }
  }
}
</script>

<style>
.rowalt:nth-child(even){
  background: #CCC;
}
</style>
